import { useEffect, useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useOrdersContext } from '@/contexts/OrderContext';
import { toast } from 'react-toastify';
import useIndexedDB from '@/hooks/useIndexedDB';
import Loader from '@/components/common/Loader';

const ProtectedOrdersRoutes = () => {
    const { cart, setCart, getRestaurantId } = useOrdersContext();
    const { isInitialized, loadCart } = useIndexedDB();
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const initializeProtectedRoute = async () => {
            if (!isInitialized) {
                return;
            }

            try {
                // First try to get the restaurant ID
                const restaurantId = await getRestaurantId();

                if (restaurantId) {
                    // Try to load cart data from IndexedDB
                    const savedCart = await loadCart(restaurantId);

                    if (savedCart && savedCart.delivery_address) {
                        // If we have saved cart data with a delivery address, use it
                        setCart(prevCart => ({
                            ...prevCart,
                            ...savedCart
                        }));
                        setIsLoading(false);
                        return; // Exit early as we have valid data
                    }
                }

                // If we reach here, either:
                // 1. We don't have a restaurantId
                // 2. We don't have saved cart data
                // 3. We don't have a delivery address in the saved cart

                // Only redirect if we don't have a delivery address in either current cart or saved data
                if (!cart?.delivery_address) {
                    toast.info('Veuillez paramétrer votre adresse de livraison', {
                        position: 'top-center',
                        autoClose: 800,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        theme: 'colored',
                    });

                    if (location.pathname !== '/commande/adresse') {
                        window.location.href = '/commande/adresse';
                    } else {
                        navigate('/commande/adresse');
                    }
                }

            } catch (error) {
                console.error('Error initializing protected route:', error);
            } finally {
                setIsLoading(false);
            }
        };

        initializeProtectedRoute();
    }, [isInitialized]);

    // Show loading state while we check data
    if (isLoading) {
        return <Loader />;
    }

    return <Outlet />;
};

export default ProtectedOrdersRoutes;